const AUTH_TOKEN = {
  sit: "c291dGlsaXR5OjZjN2lvM2gzM28zMTEwZjk0Mg==",
  prep: "",
  prod: "c291dGlsaXR5OjZjNzFpbzNmOWgzMTA0MjNvMw==",
};

const config = [AUTH_TOKEN];

export default config;
